import type { DefaultRawData } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/types";
import type { ColumnChartData } from "pro-features/components/Chart/src/types";
import { getFlattenSelectedCategory } from "app/pages/industry-analysis/common/getSelectedCategory";
import { TRAFFIC_METRIC } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/const";
import { compareFunctionHof } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/utils/compareFunctionHof";
import { getFlattenedCategoriesData } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/utils/getFlattenedCategoriesData";
import { parse } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/utils/parse";
import { fixedSelectedIndustryPosition } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/utils/fixedSelectedIndustryPosition";

export const parseRawData = (rawData: DefaultRawData): ColumnChartData => {
    const categoriesData = rawData.CategoriesData;
    const flattenedCategoriesData = getFlattenedCategoriesData(categoriesData);
    const flattenedCategory = getFlattenSelectedCategory();
    const compareFunction = compareFunctionHof(flattenedCategory);
    const sortedFlattenedCategoriesData = fixedSelectedIndustryPosition(
        flattenedCategoriesData.sort(compareFunction),
        flattenedCategory,
    );
    return parse(sortedFlattenedCategoriesData, flattenedCategory, TRAFFIC_METRIC);
};
